import { ReactElement } from "react";
import { HubItem } from "./HubItem/HubItem";
import { AnnouncementPreviewItemModel } from "client/Api/Hub/Announcements/announcementViewer";
import { ListLayout, ListLayoutCollapseMode } from "../../../ListLayout/ListLayout";
import { TimeZone } from "client/DateAndTime/timezones";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";

export type ListProps = {
	items: ReadonlyArray<AnnouncementPreviewItemModel>;
	onNavigateToItem(id: number): void;
	trackingId: string;
	shouldReserveSpaceForFloatingActionButton?: boolean;
	timezone: TimeZone;
} & (
	{ onLoadMore?: undefined; }
	|
	{
		onLoadMore: () => void;
		isBusy: boolean;
		hasMoreItems: boolean;
	}
)
& (
	{
		collapseMode?: undefined;
	}
	|
	{
		collapseMode: ListLayoutCollapseMode;
		renderMoreButton: ReactElement;
		shouldAlwaysRenderMoreButton?: boolean;
	}
);

export const List = (props: ListProps): ReactElement => {
	const {
		items,
		trackingId,
		shouldReserveSpaceForFloatingActionButton,
		onNavigateToItem,
		timezone
	} = props;

	const isMobile: boolean = useWorkspaceMediaQuery(MediaQueryKind.Mobile);

	return (
		<ListLayout
			{...(
				props.collapseMode !== undefined
					? {
						collapseMode: props.collapseMode,
						renderMoreButton: props.renderMoreButton,
						shouldAlwaysRenderMoreButton: props.shouldAlwaysRenderMoreButton
					}
					: {
						collapseMode: undefined
					}
			)}
			trackingId={trackingId}
			hasBorderTop={isMobile}
			renderAfterItems={(
				<>
					{props.onLoadMore && (
						<ListLayout.LoadMoreIndicator
							onRequestMoreItems={props.onLoadMore}
							hasMoreItems={props.hasMoreItems}
							isLoadingData={props.isBusy}
						/>
					)}
					{shouldReserveSpaceForFloatingActionButton && (
						<ListLayout.MobilePlusMenuSpacing />
					)}
				</>
			)}
		>
			{items.map(item => (
				<ListLayout.Item
					key={item.id}
				>
					<HubItem
						item={item}
						onNavigate={() => onNavigateToItem(item.id)}
						trackingId={`announcement-card|${item.id}`}
						timezone={timezone}
					/>
				</ListLayout.Item>
			))}
		</ListLayout>
	);
};

List.displayName = "List";